import { CustomFieldHelper } from "../../shared/CustomFieldHelper";
import { store } from "../store";
import ReportActions from 'bukku/redux/Report/actions';
import _ from "underscore";
import { getAccessTokenAndCompanySubdomain } from "../../shared/ApiService/helper/getAccessTokenAndCompanySubdomain";
import getReportPrintableType from "../../helpers/getReportPrintableType";
import dayjs from "dayjs";

const {
    readReportCustomFields,
} = ReportActions;

/**
**
* This function merges fields into transactions by id
* eg: transaction: [ {id: 1, ..., field_1: '1st field} ]
* eg: fields: [ {id:1, fields: [{id:6, value: '6thfield'}]} ]
* RESULT: [ {id: 1, ... , field_1: '1st field', field_6: '6thfield}]
* TRY IT OUT HERE: https://codesandbox.io/s/merge-array-of-objects-6kh6k?file=/src/App.js
* @param {[{id}]} transaction
* @param {[{id:Int, fields:[{id:Int, value:String}]}]} fields
*/
export const mergeFieldsToTransactions = (transaction, fields) => {
    if (!transaction || !fields)
        return transaction;

    return transaction.map(item => {
        const matchField = fields.find(fieldObj => fieldObj.id === item.id);
        // no match
        if (!matchField)
            return item;
        // match found

        const newFields = {};
        matchField.fields.forEach(field => {
            newFields[`field_${field.id}`] = field.value;
        });

        return {
            ...item,
            ...newFields,
        };
    });
};

/**
 * used in componentDidUpdate to fetch custom fields on demand
 * @param {String} columnsSelectedList Keys of Columns [Array]
 */
const doReadReportCustomFields = columnsSelectedList => {
    const {filterState} = store.getState().Report;
    // console.log('aaa readReportCustomFields2', {filterState, columnsSelected, colKey});
    const {
        date_preset,
        date_range,
        type,
        tag_ids,
    } = filterState;

    const requestData = {
        type,
        tag_ids,
        date_preset,
        date_from: date_range[0].format('YYYY-MM-DD'),
        date_to: date_range[1].format('YYYY-MM-DD'),
        field_ids: CustomFieldHelper.getFieldIds(columnsSelectedList, { arrayFormat: 'bracket' }),
    };

    // console.log('aaa readReportCustomFields2', {requestData, readReportCustomFields});
    store.dispatch(readReportCustomFields(requestData));
};

export const ReportCustomFieldHelper = {
/**
 * used in componentDidUpdate to fetch custom fields on demand (when custom columns are changed)
 * @param {String} storageKey           Enums of StorageKey
 * @param {*} prevColumnsSelected   from componentDidUpdate's prevProps.columnsSelected
 *                                  [] will always fetch
 */
    handleColumnsChange: (storageKey, prevColumnsSelected = []) => {
        const { Report, LocalStorage } = store.getState();

        const {requestedFieldKeys} = Report;
        const { columns: columnsSelected } = LocalStorage[storageKey];
        // columnsSelected is an array (not object)

        // change from object to list format containing the column keys
        // eg {'name': 0, 'type': 0, ...} to ['name', 'type']
        const columnsSelectedList = columnsSelected.map(c => c.key);
        const prevColumnsSelectedList = prevColumnsSelected.map(c => c.key);

        const newFieldCols = _.difference(columnsSelectedList, prevColumnsSelectedList)
            .filter(colKey => colKey.indexOf('field_') !== -1);

        // have newly added field (not exist in current reportData) - to prevent unnecessary backend call
        if (!newFieldCols.every(field => requestedFieldKeys.includes(field)))
            doReadReportCustomFields(columnsSelectedList);
    },

};

const apiUrl = process.env.REACT_APP_PROXY_API_URL;

// POST request to export report using hidden form as payload
// this approach is to solve filename issue with Blob
// https://webmasters.stackexchange.com/a/7963
/**
 *
 * @param {String} reportType - eg: transaction_list
 * @param {String} format - pdf | xls
 * @param {Object} request - request body
 */
export function exportReportByPostForm(reportType, format, request, label) {
    const form = document.createElement("form");
    form.id = "export-report-form";
    form.method = "POST";

    form.action = `${apiUrl}/reports/${reportType}/${format}`;

    if (format === 'pdf') {
        form.target = "_blank"; // open in new tab (inline)

        const reportLabel = label.replace(/[\\/]/g, "-");

        const filename = encodeURIComponent(`${dayjs().format('YYYYMMDD')} - ${reportLabel}`);
        form.action += `/${filename}`;
    }

    // add request body as hidden input
    Object.keys(request).forEach(key => {
        const input = document.createElement('input');
        const value = request[key];

        // https://bukku.atlassian.net/browse/ENG-3541?atlOrigin=eyJpIjoiNjNiNDVhZWFhYWYzNGRkY2IzZGZiNWFlNDcwNjg4YjMiLCJwIjoiaiJ9
        if (value && ['product_ids', 'tag_ids', 'field_ids'].includes(key)) {
            // have to pass in one by one instead of lumpsum. If pass in all ids as one, eg "2,3,5", backend would read it as "2,3,5".
            // If pass in the ids separately like below, only backend would be able to read as "2", "3", "5"
            value.forEach(id => {
                const inputElement = document.createElement('input');
                inputElement.type = 'hidden';
                inputElement.name = `${key}[]`;
                inputElement.value = id;
                form.appendChild(inputElement);
            });
        }
        // ignore undefined value
        else if (value) {
            const isArray = Array.isArray(request[key]);
            input.type = 'hidden';
            input.name = `${key}${isArray ? '[]' : ''}`;
            input.value = request[key];
            form.appendChild(input);
        }
    });

    // add token and company subdomain for authorization
    const { accessToken, companySubdomain } = getAccessTokenAndCompanySubdomain();
    const csInput = document.createElement('input');
    csInput.type = 'hidden';
    csInput.name = 'cs';
    csInput.value = companySubdomain;
    form.appendChild(csInput);

    const tokenInput = document.createElement('input');
    tokenInput.type = 'hidden';
    tokenInput.name = 'token';
    tokenInput.value = accessToken;
    form.appendChild(tokenInput);

    document.body.appendChild(form);
    form.submit();
}
